import React, { useState } from 'react';
import { Form, Row, Col, Button, Modal } from 'react-bootstrap';
import { Plus } from 'react-bootstrap-icons';
import MenuAllergens from './MenuAllergens';
import { ALLERGENS } from './MenuAllergens';
import './MenuItem.css';

const MenuItem = ({ item, onUpdateItem, onRemoveItem }) => {
  const [showAllergensModal, setShowAllergensModal] = useState(false);

  return (
    <div className="menu-item">
      <div className="item-content"> {/* Nuovo wrapper */}
        <Row className="g-0"> {/* Keep g-0 to control spacing manually */}
          <Col xs={12} md={6} className="pe-md-3"> {/* Add padding-end on md and up */}
            <Form.Group className="mb-3">
              <Form.Control
                type="text"
                value={item.name || ''}
                onChange={(e) => onUpdateItem('name', e.target.value)}
                placeholder="Nome"
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Control
                type="number"
                value={item.price || ''}
                onChange={(e) => onUpdateItem('price', e.target.value)}
                placeholder="€0.00"
              />
            </Form.Group>
          </Col>

          <Col xs={12} md={6} className="ps-md-3"> {/* Add padding-start on md and up */}
            <Form.Group className="mb-3">
              <Form.Control
                as="textarea"
                rows={3}
                value={item.description || ''}
                onChange={(e) => onUpdateItem('description', e.target.value)}
                placeholder="Descrizione"
              />
            </Form.Group>
          </Col>
        </Row>

        <Row className="g-0"> {/* Aggiunto g-0 per rimuovere i gutters */}
        <Col xs={12} md={6}>
            <Form.Group>
              <Button 
                variant="outline-primary" 
                size="sm"
                onClick={() => setShowAllergensModal(true)}
                className="d-flex align-items-center"
              >
                <Plus size={16} className="me-1" />
                Aggiungi Allergeni
                {item.allergens?.length > 0 && (
                  <span className="ms-2 badge bg-primary">{item.allergens.length}</span>
                )}
              </Button>
              {item.allergens?.length > 0 && (
                <div className="d-flex flex-wrap gap-2 mt-2">
                  {item.allergens.map(allergenKey => {
                    const allergen = ALLERGENS[allergenKey];
                    if (!allergen) return null;
                    const Icon = allergen.icon;
                    return (
                      <div 
                        key={allergenKey}
                        title={allergen.label}
                        style={{
                          backgroundColor: '#ffffff',
                          padding: '4px',
                          borderRadius: '4px',
                          boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                        }}
                      >
                        <Icon 
                          width={24} 
                          height={24}
                          outerColor={allergen.color}
                          innerColor="#ffffff"
                        />
                      </div>
                    );
                  })}
                </div>
              )}
            </Form.Group>
          </Col>
        </Row>
          {/* secondo bottone delete in basso a destra
        <div className="text-end mt-3">
          <Button
            variant="outline-danger"
            onClick={onRemoveItem}
            className="btn-sm"
          >
            <Trash size={16} />
          </Button>
        </div> */}

        <Modal 
          show={showAllergensModal} 
          onHide={() => setShowAllergensModal(false)}
          size="lg"
          dialogClassName="allergens-modal-dialog"
          contentClassName="allergens-modal-content"
        >
          <Modal.Header closeButton className="bg-white border-bottom">
            <Modal.Title>Gestione Allergeni</Modal.Title>
          </Modal.Header>
          <Modal.Body className="bg-white">
            <MenuAllergens
              selectedAllergens={item.allergens || []}
              onChange={(allergens) => onUpdateItem('allergens', allergens)}
            />
          </Modal.Body>
          <Modal.Footer className="bg-white border-top">
            <Button variant="info" onClick={() => setShowAllergensModal(false)}>
              Salva
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
};

export default MenuItem;